var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_c('v-clamp',{style:(_vm.customStyles),attrs:{"autoresize":_vm.autoresize,"max-lines":_vm.maxLines}},[_vm._t("default")],2)],1)]}}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }